export interface PACKAGEProducts {
  Region: string;
  FnaProductCode: string;
  EffectiveDate: string;
  Status: string;
  ProductName: string;
  Generation: string;
  Brand: string;
  Term: string;
  Type: string;
  IsRenewable: string;
  TotalListPrice: string;
  TotalDiscount: string;
  NetPrice: string;
  errorDescription: string;
  Tags: string;
  Category: string;
}

export const packageColumnsV1 = ['Region', 'FnaProductCode', 'EffectiveDate', 'Status', 'ProductName', 'Generation', 'Brand', 'Term', 'Type',
  'IsRenewable', 'TotalListPrice', 'TotalDiscount', 'NetPrice', 'errorDescription'];

export const packageColumnsV2 = ['Region', 'FnaProductCode', 'EffectiveDate', 'Status', 'ProductName', 'Generation', 'Brand', 'Term', 'Type',
  'IsRenewable', 'TotalListPrice', 'TotalDiscount', 'NetPrice', 'errorDescription', 'TAGS', 'Category'];

export const initialPACKAGEProducts: PACKAGEProducts = {
  Region: '',
  FnaProductCode: '',
  EffectiveDate: '',
  Status: '',
  ProductName: '',
  Generation: '',
  Brand: '',
  Term: '',
  Type: '',
  IsRenewable: '',
  TotalListPrice: '',
  TotalDiscount: '',
  NetPrice: '',
  errorDescription: '',
  Tags: '',
  Category: ''
};

export const packagecolumnToPropertyMapping = {
  'Region': 'Region',
  'FnaProductCode': 'FnaProductCode',
  'EffectiveDate': 'EffectiveDate',
  'Status': 'Status',
  'ProductName': 'ProductName',
  'Generation': 'Generation',
  'Brand': 'Brand',
  'Term': 'Term',
  'Type': 'Type',
  'IsRenewable': 'IsRenewable',
  'TotalListPrice': 'TotalListPrice',
  'TotalDiscount': 'TotalDiscount',
  'NetPrice': 'NetPrice',
  'errorDescription': 'errorDescription',
  'TAGS': 'Tags',
  'Category': 'Category'
};
